import { AxiosInstance, AxiosResponse } from 'axios';
import ColisportApiResource from './colisport-api-resource.model';
import { Department } from '../../models/department.model';
import InternationalCountries from '../../models/international-countries.model';

export default class InternationalCountriesApi implements ColisportApiResource {
  readonly apiUrlPath = 'internationalPostalCodes';

  constructor(readonly httpClient: AxiosInstance) {}

  getAllCountries(): Promise<AxiosResponse<string[]>> {
    return this.httpClient.get(`${this.apiUrlPath}`);
  }

  getDepartmentsWithFilters(
    countryCode: string,
    filter: string,
  ): Promise<AxiosResponse<Department[]>> {
    return this.httpClient.get(`${this.apiUrlPath}/find/${countryCode}/${filter}`);
  }

  getCountryCode(country: string): Promise<AxiosResponse<string>> {
    return this.httpClient.get(`${this.apiUrlPath}/country/${country}`);
  }

  getAll(): Promise<AxiosResponse<InternationalCountries[]>> {
    return this.httpClient.get(`${this.apiUrlPath}/list`);
  }

  createSingleCollection(
    countryName: string,
    countryCode: string,
    vatPercentage: number,
  ): Promise<AxiosResponse<InternationalCountries[]>> {
    return this.httpClient.post(`${this.apiUrlPath}`, { countryName, countryCode, vatPercentage });
  }

  deleteCountry(countryCode: string): Promise<AxiosResponse<InternationalCountries[]>> {
    return this.httpClient.delete(`${this.apiUrlPath}/${countryCode}`);
  }
}
